module.exports = __webpack_public_path__ + "img/loc.8acd4447.png";